﻿import React, { useState } from 'react';
import { BenchSheetColumn } from '../models/bench-sheet-column';
import { HplcColumnHeader } from '../models/hplc-column-header';
import { FieldUpdate } from '../models/field-update';
import { HplcColumnEntry } from '../models/hplc-column-entry';
import { NumberBoxComponent } from './NumberBoxComponent';
import HplcColumnLogbookLookup from './HplcColumnLogbookLookup';
import { ItemBasicInformation } from '../models/item-basic-information';
import ItemBasicInformationDialog from './ItemBasicInformationDialog';

import { Button } from 'devextreme-react/button';
import { Popup as DialogPopup } from 'devextreme-react/popup';

let key = 0;

export interface Props {
    id?: number; //index 1-4 of IC Column 
    column?: BenchSheetColumn;
    columnHeader?: HplcColumnHeader;
    columnEntry?: HplcColumnEntry;
    columnCompartmentTemp?: number;
    notes?: string;
    onColumnValueChanged?: (e: FieldUpdate) => void;
    onColumnDeleted?: (e: any) => void;
    onCreateNewColumnEntry?: (id: number, columnEntry: HplcColumnEntry) => void;
    readOnly?: boolean;
}

export default function IcColumnComponent(props: Props) {
    const [itemBasicInformation, setItemBasicInformation] =
        useState<ItemBasicInformation>()

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>();

    const [columnSearchDialogVisible, setColumnSearchDialogVisible] =
        useState<boolean>();

    key++;

    return (
        <div className="pw-form-section">
            <div className="pw-comp-row">Column {props.column ? props.column.sequence : ''}
                <div className="title-bar-spacer" />
                <div className="pw-margin-right-05 pw-margin-top-05">
                    <Button className="title-bar-button"
                        text="" icon="info" type="success"
                        hint="item information"
                        onClick={showInformationDialog} />
                </div>
            </div>
            <div>
                <div className="pw-comp-row">
                    <div className="pw-bordered-pane">
                        <div className="pw-comp-row">
                            <div className="pw-form-unit pw-comp-10">
                                <div className="pw-form-unit-label">Column ID</div>
                                <div className="pw-readonly-label">{props.column &&
                                    props.column.columnId ?
                                    props.column.columnId : 'NA'}</div>
                            </div>
                        </div>
                        <div className="pw-comp-row">
                            <div className="pw-form-unit pw-comp-10">
                                <div className="pw-form-unit-label">Brand</div>
                                <div className="pw-readonly-label">{props.column &&
                                    props.column.description ?
                                    props.column.description : 'NA'}</div>
                            </div>
                        </div>
                        <div className="pw-comp-row">
                            <div className="pw-form-unit pw-comp-10">
                                <div className="pw-form-unit-label">Part#</div>
                                <div className="pw-readonly-label">{props.column &&
                                    props.column.vendorPartNumber ?
                                    props.column.vendorPartNumber : 'NA'}</div>
                            </div>
                        </div>
                        <div className="pw-comp-row">
                            <div className="pw-form-unit pw-comp-10">
                                <div className="pw-form-unit-label">Vendor Serial#</div>
                                <div className="pw-readonly-label">{props.column &&
                                    props.column.vendorSerialNumber ?
                                    props.column.vendorSerialNumber : 'NA'}</div>
                            </div>
                        </div>
                        <div className="pw-comp-row">
                            <div className="pw-form-unit pw-comp-20">
                                <div className="pw-form-unit-label">Dimensions</div>
                                <div className="pw-readonly-label">{props.column &&
                                    props.column.dimensions ?
                                    props.column.dimensions : 'NA'}</div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="pw-comp-row">
                            <div className="pw-form-unit pw-comp-15">
                                <div className="pw-form-unit-label">Column Entry ID</div>
                                <div className="pw-readonly-label">{props.columnEntry &&
                                    props.columnEntry.entryId ?
                                    props.columnEntry.entryId : 'NA'}</div>
                            </div>
                        </div>

                        <div className="pw-comp-row">
                            <div className="pw-form-unit pw-comp-20">
                                <label className="pw-form-unit-label">Compartment Temperature</label>
                                <NumberBoxComponent id="compartmentTemperature" readOnly={props.readOnly}
                                    cid="621415F4-3571-4C62-AAC5-FC72A1DC3D1F"
                                    fixedUnit={'°C'} format="#.#"
                                    onValueChanged={onColumnValueChanged}
                                    value={props.column && props.column.compartmentTemperature ?
                                        props.column.compartmentTemperature : undefined} />
                            </div>
                        </div>

                        <div className="pw-comp-row">
                            <div className="pw-form-unit">
                                <Button onClick={showColumnSearchDialog} height="2rem" disabled={props.readOnly}
                                    text="Search Columns" icon="search" type="success" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <DialogPopup visible={columnSearchDialogVisible}
                onHiding={hideColumnSearchDialog}
                title="HPLC Column Search"
                shading={true} shadingColor="#999999ab"
                resizeEnabled={true}
                width={'65em'}
                height={'41em'}>

                {/*
                <HplcColumnLogbookLookup
                    onCreateNewEntry={onCreateNewEntry}
                    onCancel={hideColumnSearchDialog} />
                    */}
            </DialogPopup>

            {itemBasicInformationDialogVisible &&
                <DialogPopup visible={itemBasicInformationDialogVisible}
                    onHiding={hideItemBasicInformationDialog}
                    title="Item Basic Information"
                    width={'25rem'}
                    height={'21rem'}
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <ItemBasicInformationDialog initInformation={itemBasicInformation}
                        onOkClick={hideItemBasicInformationDialog}
                        key={`IBI${key}`} />
                </DialogPopup>
            }

        </div>
    );

    function showColumnSearchDialog(e: any) {
        setColumnSearchDialogVisible(true)
    }

    function hideColumnSearchDialog() {
        setColumnSearchDialogVisible(false);
    }

    function onCreateNewEntry(columnHeader: HplcColumnHeader) {
        if (props.id && props.onCreateNewColumnEntry)
            props.onCreateNewColumnEntry(props.id, columnHeader);
    }

    function deleteColumn(e: any) {
        if (props.column && props.column.benchSheetColumnId) {
            if (props.onColumnDeleted)
                props.onColumnDeleted(props.column.benchSheetColumnId);
        }
    }

    function onColumnValueChanged(e: any) {
        if (props.column && e.event && e.event.data && e.event.data.prop) {
            const fieldUpdate: FieldUpdate = {
                entity: "BenchSheetColumns",
                field: e.event.data.prop,
                value: e.value,
                rowId: props.column.benchSheetColumnId,
                routeId: props.column.sequence
            };

            if (props.onColumnValueChanged)
                props.onColumnValueChanged(fieldUpdate);
        }
    }

    function showInformationDialog() {
        if (props.column) {
            let itemBasicInformation: ItemBasicInformation = {
                rowPointer: props.column.benchSheetColumnId,
                createTimestamp: props.column.createTimestamp,
                lastModifiedTimestamp: props.column.modifyTimestamp,
                createUser: props.column.createUser,
                modifyUser: props.column.modifyUser
            };

            setItemBasicInformation(itemBasicInformation);
            setItemBasicInformationDialogVisible(true);
        }
    }

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }
}